// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__odJMU","information":"Footer_information__te2n3"};